<div class="modal fade" id="coSignerModal" tabindex="-1" role="dialog" aria-labelledby="coSignerModal"
    aria-hidden="true" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg w750" role="document">
        <div class="component-container modal-content clearfix">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDialog();">
                    <img src="/assets/images/icons/close_b.svg" alt="close b" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <div class="row col-sm-12 pb-2 pt-2">
                    <div class="font-mont-semi-bold form-step-number">2</div>
                    <div class="form-step-title">
                        <h1 class="font-mont-semi-bold">Owner Information</h1>
                    </div>
                    <div class="row" *ngIf="!production">
                        <button class="btn btn-primary btn-lg auto-populate"
                            (click)="onCompleteInformationClick(owner); $event.preventDefault();">
                            <em class="fa fa-check"></em>
                        </button>
                    </div>
                </div>
                <form [formGroup]="coSignerInfo.form" (ngSubmit)="onSubmit()">
                    <div class="co-signer-section clearfix">
                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="firstName"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.firstName.errors }">First
                                    Name*</label>
                                <input type="text" formControlName="firstName" class="form-control" id="firstName"
                                    name="firstName"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.firstName.errors }">
                                <div *ngIf="submitted && coSignerForm.firstName.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.firstName.errors.required">
                                        First Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="lastName"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.lastName.errors }">Last
                                    Name*</label>
                                <input type="text" formControlName="lastName" class="form-control" id="lastName"
                                    name="lastName"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.lastName.errors }">
                                <div *ngIf="submitted && coSignerForm.lastName.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.lastName.errors.required">
                                        Last Name is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-6 bsDatepicker">
                                <label for="birthDate"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.birthDate.errors }">Date of
                                    Birth*</label>
                                <input type="text" formControlName="birthDate" class="form-control" id="birthDate"
                                    name="birthDate"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.birthDate.errors }"
                                    bsDatepicker
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', isAnimated: true, containerClass: 'theme-dark-blue' }"
                                    [maxDate]="maxAgeDate">
                                <div *ngIf="submitted && coSignerForm.birthDate.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.birthDate.errors.required">
                                        Birth Date is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="socialSecurityNumber"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.socialSecurityNumber.errors }">Social
                                    Security Number*</label>
                                <input type="text" formControlName="socialSecurityNumber" class="form-control"
                                    id="socialSecurityNumber" name="socialSecurityNumber" [showMaskTyped]="true"
                                    mask="000-00-0000"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.socialSecurityNumber.errors }">
                                <div *ngIf="submitted && coSignerForm.socialSecurityNumber.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="coSignerForm.socialSecurityNumber.errors.required">
                                        Social Security Number is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="mobilePhoneNumber"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.mobilePhoneNumber.errors }">Mobile
                                    Phone*</label>
                                <input type="text" formControlName="mobilePhoneNumber" class="form-control"
                                    id="mobilePhoneNumber" placeholder="Home Phone Number" name="mobilePhoneNumber"
                                    [showMaskTyped]="true" mask="(000) 000-0000"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.mobilePhoneNumber.errors }">
                                <div *ngIf="submitted && coSignerForm.mobilePhoneNumber.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="coSignerForm.mobilePhoneNumber.errors.required">
                                        Mobile Phone Number is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="ownershipPercentage"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.ownershipPercentage.errors }">Owner
                                    Percentage*</label>
                                <input type="text" formControlName="ownershipPercentage" class="form-control"
                                    id="ownershipPercentage" name="ownershipPercentage"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.ownershipPercentage.errors }"
                                    mask="percent" suffix=" %">
                                <div *ngIf="submitted && coSignerForm.ownershipPercentage.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="coSignerForm.ownershipPercentage.errors.required">
                                        Owner Percentage is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-6">
                                <label for="coSignerEmail" class="font-mont-book"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.email.errors }">Email Address:
                                    *</label>
                                <input type="email" formControlName="email" class="form-control" id="coSignerEmail"
                                    name="email" [ngClass]="{ 'is-invalid': submitted && coSignerForm.email.errors }">
                                <div *ngIf="submitted && coSignerForm.email.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.email.errors.required">
                                        Email Address is required.
                                    </div>
                                    <div *ngIf="coSignerForm.email.errors.email">
                                        Invalid email address.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <div class="sameAsBusiness-form">
                                    <input type="checkbox" id="sameAsBusinessSigner"
                                        [formControl]="coSignerForm.sameAsBusiness" name="sameAsBusinessSigner"
                                        (click)="onSetSameBusiness()">
                                    <span class="pl-2">Same as Business </span>
                                </div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="homeAddress"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.homeAddress.errors }">Home
                                    Street
                                    Address*</label>
                                <input type="text" formControlName="homeAddress" class="form-control" id="homeAddress"
                                    name="homeAddress"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.homeAddress.errors }">
                                <div *ngIf="submitted && coSignerForm.homeAddress.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.homeAddress.errors.required">
                                        Home Street Address is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="zipCode"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.zipCode.errors }">Zip*</label>
                                <input type="text" formControlName="zipCode" class="form-control" id="zipCode"
                                    name="zipCode" (keyup)="onZipCodeKeyUpHandler(coSignerForm)"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.zipCode.errors }">
                                <div *ngIf="submitted && coSignerForm.zipCode.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.zipCode.errors.required">
                                        Zip Code is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6 select">
                                <label for="cocity"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.city.errors }">City*</label>
                                <select formControlName="city" id="cocity" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.city.errors }">
                                    <option *ngFor="let city of cities" [ngValue]="city">{{city}}</option>
                                </select>
                                <div *ngIf="submitted && coSignerForm.city.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.city.errors.required">
                                        City is required.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-6 select">
                                <label for="costate"
                                    [ngClass]="{ 'color-red': submitted && coSignerForm.state.errors }">State*</label>
                                <select formControlName="state" id="costate" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && coSignerForm.state.errors }"
                                    [attr.disabled]="true">
                                    <option *ngFor="let state of states" [ngValue]="state.code">{{state.name}}</option>
                                </select>
                                <div *ngIf="submitted && coSignerForm.state.errors" class="invalid-feedback">
                                    <div *ngIf="coSignerForm.state.errors.required">
                                        State is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="owner-info-section clearfix">
                        <div class="form-row">
                            <div class="form-group col-sm-12 autorize">
                                <div>
                                    <input type="checkbox" id="creditAuth" [formControl]="coSignerForm.creditAuth"
                                        name="creditAuth">
                                    <div>
                                        By clicking this box, I authorize ClickLease LLC, and its assigns, on behalf of
                                        the
                                        Applicant, Co-Applicant and any proposed guarantor(s) provided herein
                                        (collectively
                                        the “Authorizing Parties”): (1) to obtain a personal consumer credit report on
                                        each
                                        of the Authorizing Parties, (2) authorize the release to ClickLease LLC of all
                                        credit and other information ClickLease LLC may request related to the
                                        Authorizing
                                        Parties; and (3) confirm that each of the Authorizing Parties has provided
                                        his/her
                                        Credit Consent.
                                    </div>
                                </div>
                                <div>
                                    <input type="checkbox" id="creditAuthTwo" [formControl]="coSignerForm.creditAuthTwo"
                                        name="creditAuthTwo">
                                    <div>
                                        By clicking this box and providing my telephone numbers herein, I expressly
                                        consent
                                        to receive prerecorded messages and autodialed telephone calls or text messages
                                        from
                                        ClickLease at those telephone numbers, regardless of their purpose and expressly
                                        including, but not limited to, marketing purposes regarding ClickLease’s
                                        products
                                        and services. I understand that (I) my consent is not a condition of doing
                                        business
                                        with, or making a purchase of, any goods and/or services from ClickLease; (ii)
                                        these
                                        calls and messages may be subject to charges from my internet or wireless
                                        services
                                        provider; and (iii) I may opt-out of any telemarketing calls or marketing text
                                        messages at any time by communicating my opt-out request during the call,
                                        emailing
                                        my opt-out request to ClickLease at [insert email address] with the subject line
                                        “Opt out” or texting STOP in response to the text message.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-row justify-content-between footer-buttons-container">
                    <div class="form-group">
                        <button type="submit" class="btn btn-secondary btn-lg col-md-12"
                            [disabled]="coSignerForm.creditAuth.value == false" (click)="onSubmit()">DONE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-error-dialog [modalId]="errorId" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
    [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="'w600'">
</app-error-dialog>